/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import React, { useEffect } from "react";
import { useAuth0 } from "./Auth0";

type AuthWallProps = {
  children: React.ReactNode;
};

export function AuthWall({ children }: AuthWallProps) {
  const { user, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!user) {
      loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }
  }, [loginWithRedirect, user]);

  if (user) {
    return <>{children}</>;
  }

  return <div />;
}
